import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import routes from '../routes'
import { NotificationDb } from '../firebaseConfig'
import { useListVals } from 'react-firebase-hooks/database'
import Amplitude from '../utils/amplitudeHelper'
import { logoutUser } from 'src/ducks/auth'
import { showGlobalModal } from 'src/ducks/layout'
import { GlobalModalTypes } from './GlobalModals/GlobalModalContainer'
import { BiHomeAlt2 } from 'react-icons/bi'
import { TbNotification } from 'react-icons/tb'
import { LuInfo } from 'react-icons/lu'

const MobileNav = React.memo(() => {
  const location = useLocation()
  const dispatch = useDispatch()
  const history = useHistory()
  const currentUser = useSelector((state) => state.auth.currentUser)
  const [values, loading] = useListVals(NotificationDb)
  const [unread, setUnread] = useState(false)

  useEffect(() => {
    if (values && !loading) {
      if (values.length < localStorage.getItem('IA_notifications')) {
        localStorage.setItem('IA_notifications', 0)
      }
      setUnread(values.length > localStorage.getItem('IA_notifications'))
    }
  }, [values, loading])

  const handleNotification = () => {
    Amplitude.clickNotification()
    history.push(routes.notifications)
    setUnread(false)
  }

  const handleLogout = () => {
    Amplitude.clickLogout()
    logoutUser(dispatch, currentUser, location.pathname, 'You have logged out')
  }

  const showHelpDesk = () => {
    const cpt = window.chaport
    cpt.on('ready', function () {
      cpt.setVisitorData({
        name: currentUser.fullName,
        email: currentUser.email,
      })
      cpt.open()
    })
    cpt.on('collapsed', function () {
      cpt.close()
    })
    Amplitude.clickHelpDesk()
  }

  return (
    <Page>
      <div className="navbar">
        <Link className="nav-item" to={routes.lobby}>
          <BiHomeAlt2 size={30} />
          <span>Lobby</span>
        </Link>
        <div className={`nav-item ${unread ? 'with-shake' : ''}`} onClick={handleNotification}>
          <TbNotification size={30} />
          <div className="notification-indicator" style={unread ? { backgroundColor: 'red' } : { display: 'none' }}></div>
          <span>Notification</span>
        </div>
        <div className="nav-item" onClick={showHelpDesk}>
          <LuInfo size={30} />
          <span>Help Desk</span>
        </div>
        <div className="nav-item" onClick={handleLogout}>
          <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M30.2272 14.6348C30.2389 14.6212 30.2487 14.6065 30.2594 14.5919C30.2701 14.5773 30.2857 14.5578 30.2974 14.5403C30.3091 14.5227 30.3188 14.5052 30.3295 14.4877C30.3402 14.4701 30.349 14.4555 30.3578 14.439C30.3666 14.4224 30.3753 14.4029 30.3841 14.3844C30.3928 14.3659 30.4006 14.3503 30.4084 14.3328C30.4162 14.3152 30.4221 14.2967 30.4279 14.2792C30.4338 14.2616 30.4416 14.2412 30.4484 14.2217C30.4552 14.2022 30.4581 14.1856 30.462 14.1671C30.4659 14.1486 30.4727 14.1281 30.4766 14.1077C30.4805 14.0872 30.4835 14.0648 30.4864 14.0444C30.4893 14.0239 30.4922 14.0093 30.4942 13.9918C30.5019 13.913 30.5019 13.8337 30.4942 13.755C30.4942 13.7374 30.4893 13.7199 30.4864 13.7024C30.4835 13.6848 30.4805 13.6595 30.4766 13.639C30.4727 13.6186 30.4669 13.5991 30.462 13.5796C30.4572 13.5601 30.4533 13.5426 30.4484 13.525C30.4435 13.5075 30.4357 13.487 30.4289 13.4676C30.4221 13.4481 30.4162 13.4315 30.4094 13.414C30.4026 13.3964 30.3938 13.3789 30.3851 13.3623C30.3763 13.3458 30.3685 13.3253 30.3587 13.3078C30.349 13.2902 30.3393 13.2756 30.3305 13.259C30.3217 13.2425 30.31 13.224 30.2984 13.2064C30.2867 13.1889 30.273 13.1723 30.2604 13.1548C30.2477 13.1373 30.2399 13.1256 30.2282 13.1119C30.2029 13.0817 30.1766 13.0525 30.1493 13.0242L26.5443 9.41925C26.4332 9.30528 26.3005 9.21452 26.1541 9.15222C26.0076 9.08992 25.8502 9.0573 25.691 9.0563C25.5319 9.05529 25.3741 9.0859 25.2268 9.14635C25.0796 9.20679 24.9458 9.29587 24.8333 9.40842C24.7207 9.52097 24.6316 9.65475 24.5712 9.802C24.5107 9.94924 24.4801 10.107 24.4811 10.2662C24.4821 10.4254 24.5148 10.5828 24.5771 10.7292C24.6394 10.8757 24.7301 11.0083 24.8441 11.1194L26.403 12.6784H19.6821C19.5214 12.6738 19.3614 12.7015 19.2116 12.7598C19.0618 12.8182 18.9252 12.906 18.8099 13.018C18.6946 13.1301 18.603 13.2641 18.5404 13.4122C18.4778 13.5603 18.4456 13.7194 18.4456 13.8802C18.4456 14.041 18.4778 14.2001 18.5404 14.3482C18.603 14.4963 18.6946 14.6303 18.8099 14.7424C18.9252 14.8544 19.0618 14.9422 19.2116 15.0006C19.3614 15.0589 19.5214 15.0866 19.6821 15.082H26.3962L24.8373 16.6409C24.6165 16.8674 24.4938 17.1716 24.4958 17.4879C24.4978 17.8041 24.6243 18.1068 24.8479 18.3304C25.0716 18.5541 25.3743 18.6806 25.6905 18.6826C26.0067 18.6846 26.311 18.5619 26.5375 18.3411L30.1425 14.7361C30.171 14.6991 30.1993 14.6653 30.2272 14.6348Z"
              fill="#4B5563"
            />
            <path
              d="M20.9284 17.4788C20.7705 17.4788 20.6141 17.5099 20.4683 17.5704C20.3224 17.6308 20.1898 17.7193 20.0782 17.831C19.9665 17.9426 19.878 18.0752 19.8176 18.2211C19.7571 18.3669 19.726 18.5233 19.726 18.6812V24.6908H14.9187V5.45959C14.9188 5.20107 14.8355 4.94942 14.6812 4.74196C14.5269 4.53451 14.3099 4.38231 14.0623 4.30794L9.88635 3.05496H19.727V9.06556C19.7359 9.37838 19.8665 9.6754 20.0909 9.89352C20.3153 10.1116 20.6159 10.2337 20.9288 10.2337C21.2418 10.2337 21.5424 10.1116 21.7668 9.89352C21.9912 9.6754 22.1218 9.37838 22.1307 9.06556V1.85362C22.1307 1.53475 22.004 1.22893 21.7785 1.00346C21.553 0.777978 21.2472 0.651306 20.9284 0.651306H1.69619C1.66112 0.651306 1.62507 0.651306 1.59097 0.651306C1.35189 0.6652 1.12309 0.75328 0.936405 0.903288C0.749725 1.0533 0.614453 1.25777 0.549414 1.48825C0.540645 1.51553 0.533824 1.54281 0.527004 1.57009V1.57886C0.520509 1.60744 0.514988 1.63635 0.510441 1.66558V1.67824C0.510441 1.70552 0.503621 1.73281 0.501672 1.76009C0.499361 1.80455 0.499361 1.8491 0.501672 1.89357V25.8941C0.5014 26.1703 0.596282 26.4383 0.770357 26.6528C0.944432 26.8673 1.18708 27.0154 1.45748 27.072L13.4806 29.4767C13.6551 29.5115 13.8351 29.5073 14.0076 29.4642C14.1802 29.4211 14.3411 29.3403 14.4787 29.2275C14.6162 29.1147 14.7271 28.9728 14.8032 28.8121C14.8793 28.6513 14.9187 28.4756 14.9187 28.2977V27.0954H20.9284C21.2472 27.0954 21.553 26.9687 21.7785 26.7433C22.004 26.5178 22.1307 26.212 22.1307 25.8931V18.6831C22.1309 18.5251 22.1 18.3685 22.0397 18.2224C21.9794 18.0763 21.8909 17.9435 21.7792 17.8317C21.6675 17.7198 21.5349 17.6311 21.3889 17.5706C21.2429 17.51 21.0864 17.4788 20.9284 17.4788ZM12.5141 26.8323L2.89851 24.9061V3.471L12.5141 6.35597V26.8314V26.8323Z"
              fill="#4B5563"
            />
          </svg>

          <span>Log Out</span>
        </div>
      </div>
    </Page>
  )
})

const Page = styled.div`
  width: 100vw;
  height: 75px;
  position: sticky;
  bottom: 0;
  left: 0;
  display: inline-block;
  background: #d9d9d9;

  .navbar {
    width: 100%;
    height: 75px;
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  #menuBtn {
    width: 60px;
    height: 60px;
    position: absolute;
    bottom: 20px;
    right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    #halfCircle {
      position: absolute;
      width: 60px;
      height: 30px;
      bottom: 0;
      left: 0;
      right: 0;
      background: #fff;
      z-index: 1;
      border-radius: 0 0 10rem 10rem;
    }
    #menuIcon {
      z-index: 100;
      border-radius: 50%;
      background: #2e4b4c;
      width: 50px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      i {
        font-size: 20px;
      }
    }
  }
  #menuOverlay {
    padding: 1.5rem;
    background: #569099;
    color: #fff;
    text-align: center;
    border-radius: 28px;
    position: absolute;
    bottom: 0;
    right: 0;
    width: 90vw;
    height: 125px;
    z-index: 99;
    transition: all 300ms ease-in;
  }

  .nav-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    color: #4b5563;

    span {
      font-size: 14px;
    }
  }
  .notification-indicator {
    border: 1px solid rgba(0, 0, 0, 0.2);
    padding: 4px;
    border-radius: 50%;
    position: absolute;
    top: 4.5%;
    right: 10%;
    transition: all 300ms ease;
  }
`

export default MobileNav
